import type { ExperienceConfiguration, VariantRef } from '@ninetailed/experience.js-shared';
import type { ExperienceContextType } from './types';

/**
 * Default fallback values for experience data
 */
export const DEFAULT_EXPERIENCE_FALLBACK = 'not_available';

/**
 * Ninetailed-related constants
 */
export const NINETAILED_PREVIEW_KEY = 'ninetailed-preview';
export const NINETAILED_CLICK_EVENT = 'nt_click';

/**
 * Utility to check if an experience is valid and ready for tracking/rendering
 */
export function isExperienceValid(
  status: ExperienceContextType['status'] | undefined,
  experience?: ExperienceConfiguration<any> | null,
  audience?: { id?: string } | null,
  variant?: any,
): boolean {
  return status === 'success' && !!experience && !!audience?.id && !!variant;
}

/**
 * Helper function to safely extract variant name from a variant object
 */
export function getVariantName(variant: Record<string, unknown> | VariantRef | null): string {
  return variant && typeof variant === 'object' && 'name' in variant
    ? (variant.name as string)
    : DEFAULT_EXPERIENCE_FALLBACK;
}
